export default "__VITE_ASSET__20bed692__"